// extracted by mini-css-extract-plugin
module.exports = {"comments":"PhotoComments_comments__2hQIL"};